import React, { useState } from 'react';
import './ResetPasswordForm.css';

// Иконка стрелки влево
const ArrowLeftIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 1L1 8M1 8L8 15M1 8H19" stroke="url(#arrowGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <defs>
      <linearGradient id="arrowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#ffe866"/>
        <stop offset="100%" stopColor="#ffc814"/>
      </linearGradient>
    </defs>
  </svg>
);

const ResetPasswordForm = ({ 
  onSubmit, 
  onBack, 
  hasToken = false,
  loading = false,
  error = null,
  successMessage = null
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setPasswordError('');
    
    if (hasToken) {
      // Validate password match
      if (password !== confirmPassword) {
        setPasswordError('Пароли не совпадают');
        return;
      }
      if (password.length < 6) {
        setPasswordError('Пароль должен быть не менее 6 символов');
        return;
      }
      onSubmit?.({ password });
    } else {
      onSubmit?.({ email });
    }
  };

  return (
    <div className="reset-form">
      {/* Кнопка "Вернуться обратно" */}
      <button 
        type="button" 
        className="reset-form__back"
        onClick={onBack}
        disabled={loading}
      >
        <ArrowLeftIcon />
        <span className="reset-form__back-text">Вернуться обратно</span>
      </button>

      {/* Заголовок */}
      <h2 className="reset-form__title">
        {hasToken ? 'Новый пароль' : 'Сброс пароля'}
      </h2>
      <p className="reset-form__description">
        {hasToken 
          ? 'Введите новый пароль для вашего аккаунта'
          : 'Введите email и мы отправим вам ссылку для сброса пароля'
        }
      </p>

      {/* Сообщения */}
      {error && (
        <div className="reset-form__message reset-form__message--error">
          {error}
        </div>
      )}
      {passwordError && (
        <div className="reset-form__message reset-form__message--error">
          {passwordError}
        </div>
      )}
      {successMessage && (
        <div className="reset-form__message reset-form__message--success">
          {successMessage}
        </div>
      )}

      {/* Форма */}
      <form className="reset-form__form" onSubmit={handleSubmit}>
        {hasToken ? (
          <>
            <div className="reset-form__input-group">
              <input
                type="password"
                className="reset-form__input"
                placeholder="Новый пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                disabled={loading || successMessage}
              />
            </div>
            <div className="reset-form__input-group">
              <input
                type="password"
                className="reset-form__input"
                placeholder="Подтвердите пароль"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
                disabled={loading || successMessage}
              />
            </div>
          </>
        ) : (
          <div className="reset-form__input-group">
            <input
              type="email"
              className="reset-form__input"
              placeholder="Почта"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
        )}
        <button 
          type="submit" 
          className={`reset-form__submit ${loading ? 'reset-form__submit--loading' : ''}`}
          disabled={loading || successMessage}
        >
          {loading ? (
            <span className="reset-form__spinner" />
          ) : hasToken ? (
            'Установить новый пароль'
          ) : (
            'Отправить ссылку'
          )}
        </button>
      </form>
    </div>
  );
};

export default ResetPasswordForm;
